import { render, staticRenderFns } from "./ExamAvgScore.vue?vue&type=template&id=57bd9473&scoped=true"
import script from "./ExamAvgScore.vue?vue&type=script&lang=js"
export * from "./ExamAvgScore.vue?vue&type=script&lang=js"
import style0 from "./ExamAvgScore.vue?vue&type=style&index=0&id=57bd9473&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57bd9473",
  null
  
)

export default component.exports